import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaChevronLeft } from "react-icons/fa";

const InternetModal = ({show, handleClose }) => {
    const handleTryAgain = () => {
        window.location.reload();
    }
    return (
        <>
            <Modal dialogClassName="internet-modal" show={show} backdrop="static" keyboard={false} onHide={handleClose} centered>
                <div className='mobile-view text-md-center'>
                    <div className='mobile-view-frame d-md-inline-block h-100 position-relative text-md-start'>
                        <div className='modal-view-frame'>
                            <div className="white-box back-step rounded modal-back" onClick={handleClose}>
                                <span className="back-icon d-flex align-items-center justify-content-center"><FaChevronLeft className="text-white" /></span>
                            </div>
                            <Modal.Header>
                                <Modal.Title><h4 className="modal-title"></h4></Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="h-100 pt-0 pb-4 d-flex flex-column justify-content-center">
                                <div className="no-internet-content text-center">
                                    <img src="./images/no-internet.png" className="img-fluid mb-2" alt="no internet" />
                                    <h2 className='mb-1'>Lost connection</h2>
                                    <p className="text-white fs-5 mb-4">Please check your internet</p>
                                    <button type="button" className="btn btn-primary mt-2 w-100" onClick={handleTryAgain}>Try Again</button>
                                </div>
                            </Modal.Body>
                        </div>
                        <img src="./images/other/mobile.png" className="default-mobile-frame pe-none position-relative h-100 d-none d-md-block" alt="Mobile" />
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default InternetModal
